module.exports = __webpack_public_path__ + "static/media/es2.ebd473ad.png";